import React from 'react';

interface ToggleProps {
  name: string;
  value: boolean;
  onChange: (value: boolean) => void;
  label: string;
}

export const Toggle: React.FC<ToggleProps> = ({ value, onChange, label }) => {
  return (
    <div className="flex items-center space-x-3 w-full">
      <div
        className={`relative inline-flex h-6 w-11 sm:h-7 sm:w-12 flex-shrink-0 cursor-pointer items-center rounded-full transition-colors duration-200 ease-in-out ${
          value ? 'bg-emerald-500' : 'bg-gray-500'
        }`}
        onClick={() => onChange(!value)}
        role="switch"
        aria-checked={value}
        aria-label={label}
      >
        {/* Toggle circle */}
        <span
          className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform duration-200 ease-in-out ${
            value ? 'translate-x-5 sm:translate-x-6' : 'translate-x-0.5 sm:translate-x-1'
          }`}
        />

        {/* Checkmark icon when ON */}
        {value && (
          <svg
            className={`absolute left-1.5 h-3 w-3 text-white transition-opacity duration-200 ${
              value ? 'opacity-100' : 'opacity-0'
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
          </svg>
        )}
      </div>
      <span className="text-sm sm:text-base font-medium text-white flex-1 text-left break-words">
        {label}
      </span>
    </div>
  );
};

export default Toggle;
